import styled from 'styled-components';

import { InputWrapper } from '@/core/components/InputWrapper';

export const Textarea = styled.textarea`
  overflow: scroll;
  resize: none;
  border: 1px solid rgb(24 24 24 / 10%);
  font-family: Roboto, sans-serif;

  &:disabled {
    min-height: 100px;
    background: rgb(24 24 24 / 5%);
    color: rgb(24 24 24 / 40%);
  }

  &:not([disabled]) {
    min-height: 140px;
  }
`;

interface FormTextareaProps {
  backgroundcolor: string;
  className?: string;
  hiddenLabel?: string;
  isDisabled?: boolean;
  label?: string;
  onChange: (event: React.ChangeEvent<HTMLTextAreaElement>) => void;
  onFocus?: (event: React.ChangeEvent<HTMLTextAreaElement>) => void;
  overflow?: string;
  placeholder?: string;
  value: string;
}

export const FormTextarea = ({
  backgroundcolor,
  className,
  hiddenLabel,
  isDisabled,
  label,
  onChange,
  onFocus,
  overflow,
  placeholder,
  value,
}: FormTextareaProps) => (
  <InputWrapper
    backgroundcolor={backgroundcolor}
    error={() => false}
    fieldName="textarea"
  >
    <Textarea
      style={{
        overflow,
        // resize: 'none',
      }}
      aria-label={hiddenLabel || undefined}
      className={className}
      disabled={isDisabled}
      onChange={onChange}
      onFocus={onFocus}
      placeholder={placeholder || ''}
      tabIndex={0}
      value={value}
    />
    <span>{label}</span>
  </InputWrapper>
);

FormTextarea.defaultProps = {
  className: '',
  hiddenLabel: '',
  isDisabled: false,
  label: '',
  onFocus: () => null,
  overflow: 'scroll',
  placeholder: '',
};
